__turbopack_context__.v({
  "overlay": "GlobalLoader-module__-fefvW__overlay",
  "spin": "GlobalLoader-module__-fefvW__spin",
  "spinner": "GlobalLoader-module__-fefvW__spinner",
});
